import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { JobPortalService } from 'src/app/services/job-portal.service';
declare const L: any;
import 'leaflet-draw';
import { LatLng } from 'leaflet';
import { get } from 'http';

@Component({
  selector: 'app-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.css']
})
export class LocationListComponent implements OnInit {

  locationList: any = [];

  pageNumber: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  isLoading: any = false
  id: any

  locationForm: any | FormGroup
  cid: any
  formSubmit: boolean = false;
  latLng: any = [];

  locationUpdateForm: any | FormGroup
  isEdit: boolean = false
  singleLocationData: any = [];

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  searchFilter: any = ""
  recordName: any = ""
  recordId: any = ""




  private map!: L.Map;
  defaultCenter: any = [17.4065, 78.4772]
  defaultZoom: any = 14
  drawnItems!: L.FeatureGroup;
  userList: any = [];
  userSelectedList: any = [];
  userDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'userId',
    textField: 'userName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 6,
    allowSearchFilter: true
  };

  constructor(private generic_service: GenericService,
    private job_portal_service: JobPortalService, private fb: FormBuilder, private toastr: ToastrService) { }

  ngOnInit(): void {

    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = Number(sessionStorage.getItem('cid'))
    this.locationForm = this.fb.group({
      description: [''],
      country: ['', [Validators.required]],
      city: ['', [Validators.required]],
      zone: ['', [Validators.required]],
      provinceOrState: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      stockPoint: [false],
    })
    this.locationUpdateForm = this.fb.group({
      description: [''],
      country: ['', [Validators.required]],
      city: ['', [Validators.required]],
      zone: ['', [Validators.required]],
      provinceOrState: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      stockPoint: [false],
    })
    this.getAllLocation();
    this.getUsers();

  }

  mapLoad() {
    setTimeout(() => {
      if (this.map) {
        this.map.remove();
        this.map = undefined as any;
      }
      this.initMap();
      if (this.map) {
        this.map.invalidateSize();
      }
    }, 500);
  }

  mapLoadEdit(callback?: () => void) {
    setTimeout(() => {
      if (this.map) {
        this.map.remove();
        this.map = undefined as any;
      }
      this.initMapEdit();
      if (this.map) {
        this.map.invalidateSize();
      }

      if (callback) callback();
    }, 1000);
  }

  mapLoadView(callback?: () => void) {
    setTimeout(() => {
      if (this.map) {
        this.map.remove();
        this.map = undefined as any;
      }
      this.initMapView();
      if (this.map) {
        this.map.invalidateSize();
      }

      if (callback) callback();
    }, 1000);
  }


  ngOnDestroy() {
    if (this.map) {
      this.map.remove();
    }

    this.latLng = [];
  }


  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  getAllLocation() {
    this.isLoading = true

    this.job_portal_service.getAllLocation().subscribe(
      (res: any) => {
        console.log(res)
        this.locationList = res.response
        this.totalRecords = res.response.length
        this.isLoading = false

      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getLocationById(locationId: any) {
    this.clearMap()

    this.job_portal_service.getLocationById(locationId).subscribe(
      (response: any) => {
        this.singleLocationData = []
        this.singleLocationData.push(response.response)
        this.locationUpdateForm.patchValue({
          description: response.response.description,
          country: response.response.country,
          city: response.response.city,
          provinceOrState: response.response.provinceOrState,
          postalCode: response.response.postalCode,
          zone: response.response.zone,
          stockPoint: response.response.stockPoint
        })
        this.mapLoadEdit(() => {
          if (response.response.lngLat && response.response.lngLat.length !== 0) {
            this.drawPolygonFromApi(response.response.lngLat);
          }
        });
        this.isEdit = true
        if (response.response.usersResponsible) {
          this.userSelectedList = response.response.usersResponsible;
        } else {
          this.userSelectedList = [];
        }
      }
    )
  }

  viewLocationById(locationId: any) {
    this.clearMap()

    this.job_portal_service.getLocationById(locationId).subscribe(
      (response: any) => {
        this.singleLocationData = []
        this.singleLocationData.push(response.response)

        this.mapLoadView(() => {
          if (response.response.lngLat && response.response.lngLat.length !== 0) {
            this.drawPolygonFromApi(response.response.lngLat);
          }
        });
      }
    )
  }


  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton3")?.click()
  }

  deleteLocation() {
    this.job_portal_service.deleteLocation(this.id).subscribe(
      (response: any) => {
        this.toastr.success(response.message)
        this.getAllLocation();
        this.cancelModel();
        this.clearData()
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
      }
    )
  }

  deleteIdSelect(id: any, list: any) {
    this.id = id
    this.recordId = list.locationId
    this.recordName = list.zone
  }

  clearData() {
    this.recordId = "";
    this.recordName = "";
  }

  closePopUp() {
    this.clearMap()
    if (this.map) {
      this.map.remove();
      this.map = undefined as any;
    }
    this.recordId = "";
    this.recordName = "";
    this.userSelectedList = [];
    this.locationForm.reset()
    this.locationUpdateForm.reset()
  }

  addLocation() {

    if (this.formSubmit) {
      return
    }

    this.formSubmit = true;

    if (!this.locationForm.valid) {
      this.formSubmit = false;
      this.toastr.error("please fill required fields");
      return
    }

    if (this.locationForm.get('stockPoint').value && this.userSelectedList.length === 0) {
      this.formSubmit = false;
      this.toastr.error("Please select at least one user when Stock Point is enabled");
      return;
    }

    let points: any = []

    for (let list of this.latLng) {
      let obj = {
        "x": parseFloat(list.lng),
        "y": parseFloat(list.lat)
      }
      points.push(obj)
    }

    let usersResponsiblePayload: any = [];
    for (let user of this.userSelectedList) {
      let fullUser = this.userList.find((u: any) => u.userId === user.userId);
      if (fullUser) {
        usersResponsiblePayload.push({
          version: fullUser.version || 0,
          isActive: fullUser.isActive || true,
          description: fullUser.description || "",
          userId: fullUser.userId,
          userName: fullUser.userName,
          userMobileNo: fullUser.userMobileNo || "",
          userEmail: fullUser.userEmail || "",
          cid: this.cid
        });
      } else {
        usersResponsiblePayload.push({
          version: 0,
          isActive: true,
          description: "",
          userId: user.userId,
          userName: user.userName,
          userMobileNo: "",
          userEmail: "",
          cid: this.cid
        });
      }
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "country": this.locationForm.get('country').value,
      "city": this.locationForm.get('city').value,
      "provinceOrState": this.locationForm.get('provinceOrState').value,
      "postalCode": this.locationForm.get('postalCode').value,
      "district": "",
      "zone": this.locationForm.get('zone').value,
      "imageUrl": "",
      "latLng": [],
      "lngLat": points,
      "geometry": {
        "points": [],
        "coordinates": [
          {
            "type": "",
            "coordinates": []
          }
        ],
        "type": ""
      },
      "cid": this.cid,
      "stockPoint": this.locationForm.get('stockPoint').value || false,
      "usersResponsible": usersResponsiblePayload,
    }

    console.log(body)
    this.job_portal_service.addLocation(body).subscribe(
      (response: any) => {
        this.formSubmit = false;
        this.locationForm.reset()
        this.cancelModel()
        this.getAllLocation();
        this.clearMap()
        this.toastr.success(response.message);
      },
      (err: any) => {
        console.log(err)
        this.formSubmit = false;
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  updateLocation() {

    if (this.formSubmit) {
      return
    }

    this.formSubmit = true;
    if (!this.locationUpdateForm.valid) {
      this.formSubmit = false;
      this.toastr.error("please fill required fields");
      return
    }

    if (this.locationUpdateForm.get('stockPoint').value && this.userSelectedList.length === 0) {
      this.formSubmit = false;
      this.toastr.error("Please select at least one user when Stock Point is enabled");
      return;
    }

    let points: any = []

    for (let list of this.latLng) {
      let obj = {
        "x": parseFloat(list.lng),
        "y": parseFloat(list.lat)
      }
      points.push(obj)
    }

    let usersResponsiblePayload: any = [];
    for (let user of this.userSelectedList) {
      let fullUser = this.userList.find((u: any) => u.userId === user.userId);
      if (fullUser) {
        usersResponsiblePayload.push({
          version: fullUser.version || 0,
          isActive: fullUser.isActive || true,
          description: fullUser.description || "",
          userId: fullUser.userId,
          userName: fullUser.userName,
          userMobileNo: fullUser.userMobileNo || "",
          userEmail: fullUser.userEmail || "",
          cid: this.cid
        });
      } else {
        usersResponsiblePayload.push({
          version: 0,
          isActive: true,
          description: "",
          userId: user.userId,
          userName: user.userName,
          userMobileNo: "",
          userEmail: "",
          cid: this.cid
        });
      }
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": this.singleLocationData[0].id,
      "locationId": this.singleLocationData[0].locationId,
      "country": this.locationUpdateForm.get('country').value,
      "city": this.locationUpdateForm.get('city').value,
      "provinceOrState": this.locationUpdateForm.get('provinceOrState').value,
      "postalCode": this.locationUpdateForm.get('postalCode').value,
      "zone": this.locationUpdateForm.get('zone').value,
      "latLng": [],
      "lngLat": points,
      "geometry": {
        "points": [],
        "coordinates": [
          {
            "type": "",
            "coordinates": []
          }
        ],
        "type": ""
      },
      "cid": this.cid,
      "stockPoint": this.locationUpdateForm.get('stockPoint').value,
      "usersResponsible": usersResponsiblePayload,
    }
    console.log(body)
    this.job_portal_service.updateLocation(body).subscribe(
      (response: any) => {
        this.isEdit = false
        this.getAllLocation();
        this.cancelModel()
        this.clearMap()
        this.formSubmit = false;
        this.locationUpdateForm.reset()
        this.toastr.success(response.message);
      },
      (err: any) => {
        this.formSubmit = false;
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  refreshAll() {
    this.pageNumber = 1
    this.first = 0
    this.searchFilter = ""
    this.getAllLocation()
  }


  getUsers() {
    this.generic_service.getUsers().subscribe(
      (response: any) => {
        if (response.response == null || response.response.length == 0 || response.response == undefined) {
          this.userList = []
          return
        }
        this.userList = response.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }


  getLocationByWildSearch() {
    console.log(this.searchFilter)
    if (this.searchFilter == "" || this.searchFilter == null) {
      return
    }
    this.job_portal_service.getLocationByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.locationList = []
          this.totalRecords = 0
          return

        }
        this.locationList = res.response
        this.totalRecords = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );



  }





  private initMap(): void {

    // Initialize the map
    this.map = L.map('map', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    // Add tile layer
    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });
    tiles.addTo(this.map);

    // Create the drawn items layer group BEFORE using it
    this.drawnItems = L.featureGroup().addTo(this.map);

    // Add draw control to map
    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: this.drawnItems
      },
      draw: {
        marker: false,
        polygon: true,
        polyline: false,
        circle: false,
        rectangle: false,
        circlemarker: false
      }
    });
    this.map.addControl(drawControl);

    // Handle creation of new layers
    this.map.on(L.Draw.Event.CREATED, (event: any) => {
      const layer = event.layer;
      this.drawnItems.clearLayers();
      const points = layer.getLatLngs();

      // Flatten nested arrays (especially for polygons)
      const flatPoints = Array.isArray(points[0]) ? points[0] : points;

      let latLng: any = flatPoints.map((pt: L.LatLng) => ({
        lat: pt.lat.toString(),
        lng: pt.lng.toString()
      }));

      this.latLng = latLng

      console.log(latLng)


      // You can handle each layer type differently if needed
      if (event.layerType === 'polygon') {
        this.drawnItems.addLayer(layer);
      }
    });
  }

  private initMapView(): void {
    this.map = L.map('mapView', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      minZoom: 3,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    tiles.addTo(this.map);

    // Create the drawn items layer group
    this.drawnItems = L.featureGroup().addTo(this.map);
  }

  private initMapEdit(): void {
    this.map = L.map('mapEdit', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; OpenStreetMap'
    });
    tiles.addTo(this.map);

    this.drawnItems = L.featureGroup().addTo(this.map);

    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: this.drawnItems
      },
      draw: {
        marker: false,
        polygon: true,
        polyline: false,
        circle: false,
        rectangle: false,
        circlemarker: false
      }
    });
    this.map.addControl(drawControl);

    // ✅ Render polygon from existing coordinates (e.g. from API)
    if (this.latLng && this.latLng.length !== 0) {
      // Ensure proper format
      const latLngs = this.latLng.map((coord: any) =>
        L.latLng(coord.y ?? coord.lat, coord.x ?? coord.lng)
      );

      this.drawnItems.clearLayers();

      const polygon = L.polygon(latLngs, {
        color: 'blue',
        weight: 3
      });

      this.drawnItems.addLayer(polygon);

      // Zoom map to fit polygon
      this.map.fitBounds(polygon.getBounds());
    }

    // 🔹 Handle new polygon creation
    this.map.on(L.Draw.Event.CREATED, (event: any) => {
      const layer = event.layer;

      this.drawnItems.clearLayers();
      const points = layer.getLatLngs();
      const flatPoints = Array.isArray(points[0]) ? points[0] : points;

      this.latLng = flatPoints.map((pt: L.LatLng) => ({
        lat: pt.lat,
        lng: pt.lng
      }));

      console.log('Polygon created:', this.latLng);

      if (event.layerType === 'polygon') {
        this.drawnItems.addLayer(layer);
      }
    });

    // ✅ 🔹 Handle polygon edits
    this.map.on(L.Draw.Event.EDITED, (event: any) => {
      event.layers.eachLayer((layer: any) => {
        const points = layer.getLatLngs();
        const flatPoints = Array.isArray(points[0]) ? points[0] : points;

        this.latLng = flatPoints.map((pt: L.LatLng) => ({
          lat: pt.lat,
          lng: pt.lng
        }));

        console.log('Polygon edited:', this.latLng);
      });
    });
  }




  // private drawPolygonFromApi(data: { lat: string; lng: string }[]): void {
  //   const latLngs: L.LatLng[] = data.map(coord =>
  //     L.latLng(parseFloat(coord.lat), parseFloat(coord.lng))
  //   );

  //   const polygon = L.polygon(latLngs, {
  //     color: 'blue',
  //     fillOpacity: 0.4
  //   });

  //   this.drawnItems.clearLayers(); 
  //   this.drawnItems.addLayer(polygon);
  //   this.map.fitBounds(polygon.getBounds());
  // }


  private drawPolygonFromApi(data: any): void {
    if (!this.drawnItems || !this.map) {
      console.error('Map or drawnItems not initialized yet');
      return;
    }

    // Convert string coords to Leaflet LatLng
    const latLngs: L.LatLng[] = data.map((coord: any) =>
      L.latLng(parseFloat(coord.y), parseFloat(coord.x))
    );

    // Create polygon
    const polygon = L.polygon(latLngs, {
      color: '#60a8f2',
      fillOpacity: 0.1
    });

    this.drawnItems.clearLayers();
    this.drawnItems.addLayer(polygon);
    this.map.fitBounds(polygon.getBounds());

    // ✅ Assign latLng to class variable in case no edits happen
    this.latLng = data.map((pt: any) => ({
      lat: pt.x,
      lng: pt.y
    }));

    console.log('Loaded polygon from API:', this.latLng);
  }




  clearMap(): void {
    if (this.drawnItems) {
      this.drawnItems.clearLayers();
    }
    console.log("clear")
    // Optionally clear stored coordinates
    this.latLng = [];
  }

}